<template>
  <div class="ad-slot-preview-row">
    <div class="ad-slot-preview-row__content">
      <slot />
    </div>
    <AdDisplayPreviewButton v-if="url" :url="url" variant="icon" />
  </div>
</template>

<script>
import AdDisplayPreviewButton from './AdDisplayPreviewButton.vue';

export default {
  name: 'AdSlotPreviewRow',
  components: { AdDisplayPreviewButton },
  props: {
    url: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.ad-slot-preview-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ad-slot-preview-row__content {
  flex: 1;
  min-width: 0;

  /* 与右侧外链按钮：边框色、圆角统一 */
  ::v-deep .el-input__inner {
    border-color: rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }

  ::v-deep .multiselect__tags {
    border-color: rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }
}
</style>
